import { createSurveyStyles } from '@sm/webassets';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';

import { Theme } from '~app/sharedTypes';
import { isPartialLeft, isPartialHalf, isPartialThird, isBanner, isFull } from '~app/helpers/themeLayout';

type LayoutOptionType = Required<SurveyThemeType['layout']>;

type StyleProps = {
  isRTL: boolean;
};

// 😖
type LeftRightVals = {
  left: string;
  right: string;
};

function getWidthFromLayout(layout: LayoutOptionType): string {
  let width = '';

  if (isFull(layout) || isBanner(layout)) {
    width = '100%';
  } else if (isPartialHalf(layout)) {
    width = '50%';
  } else if (isPartialThird(layout)) {
    width = '66%';
  }
  return width;
}

function getLeftRightFromLayout(layout: LayoutOptionType): LeftRightVals {
  // Default to browser behavior
  let left = 'auto';
  let right = 'auto';

  /**
   *  PartialLeft => Partial (half or third) space is left empty on the LEFT side while survey content is on the right.
   *    * right = 0 ensures the bar is at the edge on right side.
   *    * left is set to 'auto'
   *
   *  PartialRight:
   *    * ProgressBar should be on the edge of left side => left = 0
   *    * right = 'auto'
   *
   *  isFull and isBanner:
   *    * In both these cases, progress bar already has 100% width, left = 0 ensures it sticks to left edge
   *    * right = 'auto
   */

  if (isPartialLeft(layout)) {
    right = '0';
  } else {
    left = '0';
  }

  return {
    left,
    right,
  };
}

const useStyles = createSurveyStyles((theme: Theme) => {
  const { left, right } = getLeftRightFromLayout(theme.layout);

  return {
    progressBarContainer: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      direction: 'ltr',
      background: theme.primaryAccentColor,
      position: 'fixed',
      bottom: 0,
      height: 48,
      left,
      right,
      width: getWidthFromLayout(theme.layout),
      [`@media (max-width: 600px)`]: {
        width: '100%',
      },
      [`@media (max-width: 768px)`]: {
        // If theme isn't a full layout, and width is 601px<=x<=768px
        // For half-layouts, bar has width: 67% b/w 600 and 768px(responseweb)
        width: !isFull(theme.layout) ? '66%' : '100%',
      },
    },
    text: {
      fontFamily: "'National 2'",
      color: theme.secondaryAccentColor,
      direction: ({ isRTL }: StyleProps) => (isRTL ? 'rtl' : null),
    },
    progressBar: {
      width: 200,
      marginLeft: 20,
    },
  };
});

export default useStyles;
